import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { DatePipe } from '@angular/common';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { TcPerfilUsuarioEnum } from '../../../core/_infrastructure/types/common';
import { SeguimientoService } from './seguimiento.service';
import { SolicitudService } from '../datosbasicos/datosbasicos.service';
import { TComentarioInspectorViewModel, SolicitudSeguimientoViewModel } from './seguimiento.types';
import { EnumIdsTcEstadoSolicitud, EnumIdsTwTcTipoClonacion, EnumCodigosTwTcAcciones } from '../types/enum';

@Component({
    selector: 'app-seguimiento-list',
    templateUrl: './seguimiento-list.component.html',
})
export class SeguimientoListComponent extends ComponentBase implements OnInit {
    solicitudSeguimiento: SolicitudSeguimientoViewModel;
    //seguimiento: TComentarioInspectorViewModel;
    EsSolicitante = false;
    EsInspector = false;
    EsCoordinador = false;
    EsMagrama = false;
    EsConsultas = false;
    habilitarNueva = false;
    esClonada = false;
    seguimientoEditable: boolean;
    seguimientoBorrable: boolean;
    colsObservaciones: any[];

    id = 0;
    IdEstadoSolicitud: number;
    editMode = false;
    EstadoSolicitudDescripcion: string;
    EsPredua: boolean;
    tituloTipoSolicitud: string;
    CodigoSolicitud: string;
    CodigoTipoSolicitud: string;
    IdTipoSolicitud: number;
    TComentarioInspectorCollection: TComentarioInspectorViewModel[];

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private navMenuService: NavMenuService,
        private solicitudService: SolicitudService,
        private seguimientoService: SeguimientoService,
        private confirmationService: ConfirmationService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);

        //this.seguimiento = new TComentarioInspectorViewModel();
    }

    ngOnInit() {
        this.EsSolicitante = this.isSolicitante;
        this.EsInspector = this.isInspector;
        this.EsCoordinador = this.isCoordinador;
        this.EsMagrama = this.loggedInUser!.hasProfile(TcPerfilUsuarioEnum.Magrama);
        this.EsConsultas = this.isConsultas;

        this.colsObservaciones = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Observaciones', header: 'Descripción' },
            { field: 'Inspector', header: 'Inspector' },
            { field: 'Fecha', header: 'Fecha' },
            { field: 'IdSeccionDescripcion', header: 'Seccion' },
            { field: 'IdMotivoDescripcion', header: 'Motivo' },
        ];

        this.id = this.activatedRoute.snapshot.params['id'];

        this.guardRefreshPage(this.id);

        this.form = this.fb.group({
            txtObservaciones: '',
        });

        //this.onSearchButton();

        this.seguimientoService.getSeguimientos(this.id).subscribe(result => {
            this.solicitudSeguimiento = result;

            this.IdTipoSolicitud = this.solicitudSeguimiento.IdTipoSolicitud;
            this.CodigoSolicitud = this.solicitudSeguimiento.CodigoSolicitud;
            this.CodigoTipoSolicitud = this.solicitudSeguimiento.CodigoTipoSolicitud;
            this.IdEstadoSolicitud = this.solicitudSeguimiento.IdEstadoSolicitud;
            this.tituloTipoSolicitud = this.solicitudSeguimiento.IdTipoSolicitudDescripcion;

            this.esClonada =
                this.solicitudSeguimiento.TwSolicitudJerarquia != null &&
                this.solicitudSeguimiento.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                    ? true
                    : false;
            //SI ES RE-IMPORTACION
            if (this.solicitudSeguimiento.EsReImportacion) {
                this.tituloTipoSolicitud += ' - Re-Importación';
            }
            //SI ES PREVIA
            if (this.solicitudSeguimiento.EsPrevia) {
                if (
                    this.solicitudSeguimiento.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA &&
                    this.solicitudSeguimiento.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE
                ) {
                    this.tituloTipoSolicitud += ' - Previa';
                }
            }
            this.EstadoSolicitudDescripcion = this.solicitudSeguimiento.IdEstadoSolicitudDescripcion;
            this.EsPredua = this.solicitudSeguimiento.EsPredua;
            if (this.EsSolicitante) {
                this.TComentarioInspectorCollection = this.solicitudSeguimiento.TComentarioInspectorCollection.filter(t => t.VisibleSolicitante);
            } else {
                this.TComentarioInspectorCollection = this.solicitudSeguimiento.TComentarioInspectorCollection;
            }

            this.habilitarNueva = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO, this.solicitudSeguimiento.IdEstadoSolicitud).Editable;

            this.loading = false;
        });
    }

    checkEdit(rowData: TComentarioInspectorViewModel): boolean {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO).Editable && rowData.IdInspector == this.loggedInUser!.Id;
    }
    checkDelete(rowData: TComentarioInspectorViewModel): boolean {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO).Editable && rowData.IdInspector == this.loggedInUser!.Id;
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudImportacion.Id) || this.navMenuService.currentSolicitudImportacion.Id !== id) {
            this.solicitudService.getSolicitud(id).subscribe(result => {
                this.navMenuService.currentSolicitudImportacion = result;
            });
        }
    }

    onBack() {
        this.router.navigate(['/importacion/solicitud/datosbasicos', this.id]);
    }

    onAdd() {
        this.router.navigate([this.router.url, 'create']);
    }

    onEdit(item: TComentarioInspectorViewModel) {
        this.router.navigate([this.router.url, 'detalleseguimiento', item.Id]);
    }

    onDelete(item: TComentarioInspectorViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.seguimientoService.deleteSeguimiento(item.Id).subscribe(res => {
                    this.addSuccessMessage('Seguimiento eliminado correctamente');
                    //this.onSearchButton();
                    this.ngOnInit();
                });
            },
        });
    }
}
